var map = {
	"./0x.svg": 536,
	"./0x_v3.svg": 537,
	"./1inch.svg": 538,
	"./aave.svg": 539,
	"./aave_v2.svg": 540,
	"./adelphi.svg": 541,
	"./akropolis.svg": 542,
	"./alink.svg": 543,
	"./alpha-homora.svg": 544,
	"./ampleforth.svg": 545,
	"./argent.svg": 546,
	"./armor.svg": 547,
	"./arnxm.svg": 548,
	"./balancer.svg": 549,
	"./bancor.svg": 550,
	"./bat.svg": 551,
	"./binance.svg": 552,
	"./block_fi.svg": 553,
	"./busd.svg": 554,
	"./bzx.svg": 555,
	"./celsius.svg": 556,
	"./check_circle.svg": 291,
	"./coinbase.svg": 557,
	"./coinbase_wallet.svg": 558,
	"./compound.svg": 559,
	"./compound_v2.svg": 560,
	"./connect_disconnected.svg": 292,
	"./connect_wallet.svg": 561,
	"./cream.svg": 562,
	"./curve.svg": 563,
	"./cusdc.svg": 564,
	"./cusdt.svg": 565,
	"./dai.svg": 566,
	"./ddex.svg": 567,
	"./defi_pulse.svg": 568,
	"./defisnap.svg": 569,
	"./defizap.svg": 570,
	"./deversifi.svg": 571,
	"./dforce.svg": 572,
	"./dodo.svg": 573,
	"./dxdao.svg": 574,
	"./dydx.svg": 575,
	"./eth.svg": 576,
	"./etherscan.svg": 577,
	"./fortmatic.svg": 578,
	"./ftm.svg": 579,
	"./gas_price.svg": 293,
	"./gemini.svg": 580,
	"./gift.svg": 581,
	"./hegic.svg": 582,
	"./hodlnaut.svg": 583,
	"./icn_aethereum.svg": 584,
	"./icn_ledger.svg": 585,
	"./icn_metamask.svg": 586,
	"./idex.svg": 587,
	"./idle.svg": 588,
	"./iearn.svg": 589,
	"./inlock.svg": 590,
	"./keeperdao.svg": 591,
	"./knc.svg": 592,
	"./kraken.svg": 593,
	"./ledn.svg": 594,
	"./lend.svg": 595,
	"./link.svg": 596,
	"./lock.svg": 597,
	"./maker_dao.svg": 598,
	"./mana.svg": 599,
	"./medium.svg": 600,
	"./melon.svg": 601,
	"./metamask.svg": 602,
	"./metamask_right.svg": 603,
	"./mooniswap.svg": 604,
	"./mstable.svg": 605,
	"./nexo.svg": 606,
	"./nexus_mutants.svg": 607,
	"./nucypher.svg": 608,
	"./o_curve.svg": 609,
	"./opyn.svg": 610,
	"./pooltogether.svg": 611,
	"./portis.svg": 612,
	"./protect.svg": 613,
	"./ren.svg": 614,
	"./rep.svg": 615,
	"./safe.svg": 616,
	"./sai.svg": 617,
	"./set_protocol.svg": 618,
	"./snx.svg": 619,
	"./stats.svg": 620,
	"./sushiswap.svg": 621,
	"./synthetix.svg": 622,
	"./tbtc.svg": 623,
	"./telegram.svg": 624,
	"./tornado.svg": 625,
	"./torus.svg": 626,
	"./totle.svg": 627,
	"./trezor.svg": 628,
	"./truffle.svg": 629,
	"./trust_wallet.svg": 630,
	"./tusd.svg": 631,
	"./twitter.svg": 632,
	"./uma.svg": 633,
	"./uniswap.svg": 634,
	"./usdc.svg": 635,
	"./usdt.svg": 636,
	"./wallet_connect.svg": 637,
	"./wbtc.svg": 638,
	"./yearn_finance.svg": 639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1744;